// extracted by mini-css-extract-plugin
export var buttonWithDividerContainer = "tsl-candidate-module--button-with-divider-container--378f5";
export var candidateInput = "tsl-candidate-module--candidate-input--6323b";
export var candidateList = "tsl-candidate-module--candidate-list--8fa21";
export var divider = "tsl-candidate-module--divider--b7880";
export var dividerButton = "tsl-candidate-module--divider-button--270b3";
export var dividerButtonIcon = "tsl-candidate-module--divider-button-icon--da2a4";
export var dividerButtonWrapper = "tsl-candidate-module--divider-button-wrapper--f78ac";
export var dividerWrapper = "tsl-candidate-module--divider-wrapper--0252e";
export var formField = "tsl-candidate-module--form-field--e513c";
export var formFieldError = "tsl-candidate-module--form-field-error--19f09";